import styled from 'styled-components';
import { FormControl, TextField } from '@mui/material';

export {
    Container,
    Title,
    TableContainer,
    Pagination,
    ActionButton,
    Table,
    SearchCard as WorkOrderSearchCard,
} from '../sharedTable.styled';

export const TextFeldWorkOrderSearch = styled(TextField)`
  width: 35%;
  margin-right: 20px;
`;

export const FormControlWorkOrderSearch = styled(FormControl)`
  width: 20%;
  margin-right: 20px;
`;

export const FiltersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  align-items: flex-end;
`;

/* Badge de status com bolinha colorida — facilita a leitura na lista.
   Largura padronizada: todos com o tamanho que comporta o maior status. */
export const StatusBadge = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 220px;
  max-width: 100%;
  box-sizing: border-box;
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  text-align: center;
  color: ${(p) => p.$color};
  background: ${(p) =>
    `color-mix(in srgb, ${p.$color} 14%, transparent)`};
  border: 1px solid
    ${(p) => `color-mix(in srgb, ${p.$color} 36%, transparent)`};

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(p) => p.$color};
    box-shadow: 0 0 0 3px ${(p) =>
      `color-mix(in srgb, ${p.$color} 22%, transparent)`};
  }
`;
